module.exports = __webpack_public_path__ + "a1e4a1dde7580d3ed6683eaf1d7791f9.jpg";